import * as React from 'react';
import * as PropTypes from 'prop-types';
import ToolTip01 from '../ToolTip01';
import {
  InnerWrapper,
  TitleWrapper,
  LabelTitle,
  CaptionText,
} from './elements';

type Lab114BProps = {
  onClick?: () => void;
  className?: string;
  theme?: 'light' | 'dark';
  animation?: boolean;
  decimals?: string | number;
  locale: string;
  tooltipText?: string;
  id?: string;
  icon?: string;
  iconColor?: string;
  children?: string;
  caption?: string;
};

function Lab114B(props: Lab114BProps): React.ReactElement {
  return (
    <ToolTip01
      className={props.className}
      placement="top"
      text={props.tooltipText}
    >
      <InnerWrapper id={props.id} onClick={props.onClick}>
        <TitleWrapper>
          <LabelTitle
            animation={props.animation}
            $themeName={props.theme}
            decimals={props.decimals}
            locale={props.locale}
            icon={props.icon}
            $iconColor={props.iconColor}
          >
            {props.children}
          </LabelTitle>
        </TitleWrapper>
        <CaptionText $themeName={props.theme}>{props.caption}</CaptionText>
      </InnerWrapper>
    </ToolTip01>
  );
}

Lab114B.propTypes = {
  animation: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  caption: PropTypes.string,
  decimals: PropTypes.number,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  theme: PropTypes.string,
  tooltipText: PropTypes.node,
  locale: PropTypes.string.isRequired,
};

export default Lab114B;
